module.exports = __webpack_public_path__ + "img/icon_email.svg?ed204d9ad77e3cf76e91eeadb4c147f5";